module.exports = __webpack_public_path__ + "static/pexels-thirdman-5327649-96dd7232f177d04c979518a974e9d3b6.jpg";